import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { TripDetailsModel } from "trips/models";
import tripService from "services/tripService";
import moment from "moment";
import orgDataService from "services/orgDataService";
import { getTimeline, setTimeZone } from "./vehicleTripSlice";

export const getTrip = createAsyncThunk<any, string>(
  "trip.getTrip",
  async (tripNumber: string, { dispatch }) => {
    var response = await tripService.getTrip(tripNumber);

    // Set timezone to trip's timezone if available
    if (response?.hubTimeZone?.label) {
      dispatch(setTimeZone(response.hubTimeZone.label));
    }

    // Automatically preload map data after trip is loaded
    if (response && response.vehicle?.unitNumber) {
      dispatch(preloadMapData(response));
    }

    return response;
  }
);

export const getPointsOfService = createAsyncThunk<any, any>("trip.getPointsOfService", async ({clientId, hubId}) => {
  var response =  orgDataService.getPointOfService(clientId, hubId)
  return response;
});

// Preload timeline after trip is loaded (activity data is fetched by VehicleHistory once timeline dates are ready)
export const preloadMapData = createAsyncThunk<any, TripDetailsModel>(
  "trip.preloadMapData",
  async (trip, { dispatch }) => {
    if (!trip.vehicle?.unitNumber) return { preloaded: false };

    await dispatch(getTimeline({ tripNumber: trip.tripNumber.toString(), isActive: "active" }));

    return { preloaded: true };
  }
);

interface TripInfo {
  tripData: TripDetailsModel;
  pointsOfService: any[];
  /**
   * An approve is in flight. The approval fields in the header -- Approved By above all -- are
   * about to change, and the closer has no way to tell a value that is still true from one that
   * is merely stale, so the header skeletons them rather than showing the old answer. Lives here
   * because the header reads redux and the buttons that start an approve are in the Closer tab.
   */
  approving: boolean;
}

const initialState: TripInfo = {
  tripData: undefined,
  pointsOfService: [],
  approving: false,
};
export const tripSlice = createSlice({
  name: "trip",
  initialState: initialState,
  reducers: {
    setTrip: (state, action) => {
      state.tripData = action.payload;
    },
    setApproving: (state, action) => {
      state.approving = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getTrip.fulfilled, (state, action) => {
      // The refetch that follows an approve is what the header was waiting for.
      state.approving = false;
      state.tripData = action.payload;
      state.tripData.callDateTime = moment(state.tripData.callDateTime) ?? null;
      state.tripData.pickupDateTimeLocal = moment(state.tripData.pickupDateTimeLocal) ?? null;
    });
    builder.addCase(getPointsOfService.fulfilled, (state, action) => {
      state.pointsOfService = action.payload;
    });
  },
});

export const tripData = (state) => state.trip.tripData;
export const tripApproving = (state) => state.trip.approving;
export const pointsOfService = (state) => state.trip.pointsOfService;
// Action creators are generated for each case reducer function
export const { setTrip, setApproving } = tripSlice.actions
export default tripSlice.reducer;
